module.exports = __webpack_public_path__ + "img/notfound_hero_mobile.89d90fa3.jpg";